(function () {
'use strict';
var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var mobileMq = window.matchMedia('(max-width: 820px)');
var compactMq = window.matchMedia('(max-width: 1200px)');
var $ = function (s, r) { return (r || document).querySelector(s); };
var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
var burger = $('.burger');
var navEl = $('#nav');
var megaItems = $$('.nav-item[data-mega]');
var closeAllMega = function (except) {
megaItems.forEach(function (it) {
if (it === except) return;
it.setAttribute('data-open', 'false');
var b = $('.nav-link', it);
if (b) b.setAttribute('aria-expanded', 'false');
});
};
if (burger && navEl) {
var setNav = function (open) {
navEl.classList.toggle('open', open);
burger.setAttribute('aria-expanded', open ? 'true' : 'false');
if (!open) closeAllMega();
};
burger.addEventListener('click', function () {
setNav(!navEl.classList.contains('open'));
});
navEl.addEventListener('click', function (e) {
if (e.target.closest('a')) setNav(false);
});
document.addEventListener('keydown', function (e) {
if (e.key !== 'Escape') return;
if (navEl.classList.contains('open')) { setNav(false); burger.focus(); }
else { closeAllMega(); }
});
document.addEventListener('click', function (e) {
if (e.target.closest('.hdr')) return;
if (navEl.classList.contains('open')) setNav(false);
closeAllMega();
});
}
megaItems.forEach(function (item) {
var btn = $('.nav-link', item);
if (!btn) return;
var open = function (state) {
if (state) closeAllMega(item);
item.setAttribute('data-open', state ? 'true' : 'false');
btn.setAttribute('aria-expanded', state ? 'true' : 'false');
};
var hoverable = function () {
return !compactMq.matches && window.matchMedia('(hover:hover)').matches;
};
btn.addEventListener('click', function () {
if (hoverable()) { open(true); return; }
open(item.getAttribute('data-open') !== 'true');
});
/* Hover intent. The panel used to close the instant the pointer left the
   trigger, so moving diagonally toward a card, which is the natural path,
   snapped it shut before it could be reached. Closing is now deferred and the
   timer is cancelled if the pointer arrives anywhere inside the item, panel
   included. Opening stays immediate. */
var closeTimer = null;
var cancelClose = function () { if (closeTimer) { window.clearTimeout(closeTimer); closeTimer = null; } };
item.addEventListener('mouseenter', function () { if (!hoverable()) return; cancelClose(); open(true); });
item.addEventListener('mouseleave', function () {
if (!hoverable()) return;
cancelClose();
closeTimer = window.setTimeout(function () { open(false); closeTimer = null; }, 240);
});
item.addEventListener('mouseover', function () { if (hoverable()) cancelClose(); });
item.addEventListener('focusout', function (e) {
if (!item.contains(e.relatedTarget)) open(false);
});
});
var typed = $('#typed');
if (typed) {
var out = $('.typed-txt', typed);
var lines = ['Breakfast in five minutes.', 'Kulhad doodh on the stove.', 'Panjiri by the spoon.'];
if (reduced) {
out.textContent = lines[0];
      typed.classList.add('is-typing');
} else {
var li = 0, ci = 0, erasing = false;
var tick = function () {
typed.classList.add('is-typing');
var line = lines[li];
if (!erasing) {
ci += 1;
out.textContent = line.slice(0, ci);
if (ci >= line.length) { erasing = true; return window.setTimeout(tick, 1900); }
return window.setTimeout(tick, 42);
}
ci -= 1;
out.textContent = line.slice(0, ci);
if (ci <= 0) { erasing = false; li = (li + 1) % lines.length; return window.setTimeout(tick, 260); }
return window.setTimeout(tick, 22);
};
window.setTimeout(tick, 700);
}
}
if (!reduced && 'IntersectionObserver' in window) {
var revObs = new IntersectionObserver(function (entries) {
entries.forEach(function (en) {
if (!en.isIntersecting) return;
en.target.classList.add('in');
revObs.unobserve(en.target);
});
}, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
$$('.reveal, .reveal-s').forEach(function (el) { revObs.observe(el); });
} else {
$$('.reveal, .reveal-s').forEach(function (el) { el.classList.add('in'); });
}
/* The homepage shop grid reveals 4 at a time behind a Load more button and a
   sentinel. The COLLECTION pages reuse #grid and .prod but paginate server side
   by 24, and they have neither control, so paint() was hiding every card past
   the fourth with nothing on the page able to bring them back: /collections/all
   showed three bundles and one product and stopped. Progressive reveal only
   applies where a load control actually exists. */
var grid = $('#grid');
var products = grid ? $$('.prod', grid) : [];
var loadBtn = $('#load');
var sentinel = $('#sentinel');
/* only real filter buttons; the collection page's shelf switcher uses .filter
   for styling on plain links that carry no data-filter, and treating those as
   filters set activeFilter to null and matched nothing */
var filters = $$('.filter').filter(function (f) { return f.hasAttribute('data-filter'); });
var PAGE = 4;
var progressive = !!(loadBtn || sentinel);
var shown = progressive ? PAGE : products.length;
var activeFilter = 'all';
var matching = function () {
return products.filter(function (p) {
return activeFilter === 'all' || (p.getAttribute('data-cat') || '').split(' ').indexOf(activeFilter) !== -1;
});
};
var paint = function () {
var list = matching();
products.forEach(function (p) { p.setAttribute('hidden', ''); });
list.slice(0, shown).forEach(function (p) { p.removeAttribute('hidden'); });
var more = list.length > shown;
if (loadBtn) loadBtn.parentNode.hidden = !more;
return more;
};
var loadMore = function () {
shown += PAGE;
paint();
};
if (products.length) {
paint();
if (loadBtn) loadBtn.addEventListener('click', loadMore);
filters.forEach(function (btn, i) {
btn.addEventListener('click', function () {
activeFilter = btn.getAttribute('data-filter');
shown = progressive ? PAGE : products.length;
filters.forEach(function (f) { f.setAttribute('aria-selected', f === btn ? 'true' : 'false'); });
paint();
});
btn.addEventListener('keydown', function (e) {
var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
if (!dir) return;
e.preventDefault();
var next = filters[(i + dir + filters.length) % filters.length];
next.focus(); next.click();
});
});
if (sentinel && 'IntersectionObserver' in window) {
new IntersectionObserver(function (entries) {
if (entries[0].isIntersecting && matching().length > shown) loadMore();
}, { rootMargin: '240px 0px' }).observe(sentinel);
}
}
var spots = $$('.spot');
var closeSpots = function (except) {
spots.forEach(function (s) {
if (s === except) return;
s.setAttribute('aria-expanded', 'false');
var c = document.getElementById(s.getAttribute('data-spot'));
if (c) c.classList.remove('open');
});
};
spots.forEach(function (s) {
var card = document.getElementById(s.getAttribute('data-spot'));
var openSpot = function (state) {
if (state) closeSpots(s);
s.setAttribute('aria-expanded', state ? 'true' : 'false');
if (card) card.classList.toggle('open', state);
};
s.addEventListener('click', function (e) {
e.stopPropagation();
if (window.matchMedia('(hover:hover)').matches) { openSpot(true); return; }
openSpot(s.getAttribute('aria-expanded') !== 'true');
});
s.addEventListener('mouseenter', function () { if (window.matchMedia('(hover:hover)').matches) openSpot(true); });
});
var scene = $('#scene');
if (scene) scene.addEventListener('mouseleave', function () { closeSpots(); });
document.addEventListener('click', function (e) { if (!e.target.closest('.scene')) closeSpots(); });
var anatomy = $('.anatomy');
var aScene = $('#anat-scene');
var layers = $$('.anat-layer');
function clearAnat() {
document.documentElement.classList.remove('anat-live');
layers.forEach(function (l) {
var d = $('.anat-disc', l), b = $('.anat-label', l);
if (d) { d.style.transform = ''; d.style.opacity = ''; d.style.filter = ''; d.style.zIndex = ''; }
if (b) { b.style.opacity = ''; b.style.transform = ''; }
});
if (head) { head.style.transform = ''; }
    var bw = aScene && $('.anat-bowl', aScene);
if (bw) { bw.style.transform = ''; bw.style.opacity = ''; }
}
if (anatomy && aScene && layers.length) {
var bowl = $('.anat-bowl', aScene);
var nat = [], natBowl = 0, bowlTarget = 0, bowlH = 0, narrow = false;
    var head = $('.anat-head', anatomy), headDrop = 0, converge = 0;
var STEP = 7;
var measure = function () {
  narrow = window.matchMedia('(max-width:820px)').matches;
  nat = layers.map(function (l) { return $('.anat-disc', l).offsetTop; });
  natBowl = bowl ? bowl.offsetTop : 0;
  bowlH = bowl ? bowl.offsetHeight : 0;
  if (head) {
    var stageH = head.parentNode.offsetHeight;
    headDrop = Math.max(0, (stageH - head.offsetHeight) / 2 - head.offsetTop);
    /* Bounded, not raw. measure() can run before the lazy images below the
       fold have loaded, which made natBowl stale and sent converge to ~731px
       on desktop; on mobile the single-column stack makes the gap negative and
       it clamped to 0, so nothing moved at all. A clamped travel distance keeps
       the gesture correct whatever the measurement says. */
    var gap = bowl ? (natBowl - (head.offsetTop + head.offsetHeight)) / 2 : 0;
    converge = Math.min(90, Math.max(28, Math.abs(gap)));
  }
  /* the bowl no longer travels: it drops in, lands, and stays. Everything
 emerges FROM its mouth, so the in-bowl target is measured off the bowl
 where it actually sits. */
  bowlTarget = natBowl;
};
var apply = function (p) {
  var n = layers.length;
  var ENTER = 0.10;   /* bowl drops in from above the frame */
  var SNAP  = 0.84;   /* everything returns into it, and the section closes */
  var span  = (SNAP - ENTER) / n;

  /* Computed before the bowl block: the bowl reads `back` to lift as the
     stack returns, and `var` hoisting made it undefined there, so the whole
     transform evaluated to NaN and the bowl never moved at all. */
  var back = p > SNAP ? Math.pow((p - SNAP) / (1 - SNAP), 2) : 0;

  /* 1. the bowl arrives */
  var e = Math.min(1, Math.max(0, p / ENTER));
  var eo = Math.sin(e * Math.PI / 2);
  if (bowl) {
/* The bowl drops in, then LIFTS as the stack falls back into it, so the
 two movements meet instead of the bowl sitting still while things
 land on it. A touch of scale sells the catch. */
var lift = back * converge;
bowl.style.transform = 'translateY(' + ((1 - eo) * -170 - lift) + 'px) scale(' + (1 + back * 0.06).toFixed(3) + ')';
bowl.style.opacity = String(Math.min(1, e * 2.2));
}
/* Before the bowl lands the heading sits big and centred in an empty
   stage; as the bowl arrives it rises to its place and scales down. */
if (head) {
var hp = Math.min(1, Math.max(0, p / 0.34));
var he = 1 - Math.sin(hp * Math.PI / 2);
/* One openness value drives both ends. It is 1 before the bowl lands, 0
   while the layers are out, and 1 again on the return, so the heading
   finishes at exactly the size and position it started at rather than
   shrinking into the bowl. */
var away = Math.max(he, back);
head.style.transform = 'translateY(' + (away * headDrop).toFixed(1) + 'px) scale(' + (1 + away * 0.55).toFixed(3) + ')';
head.style.transformOrigin = '50% 50%';
  }


  layers.forEach(function (layer, i) {
var t = Math.min(1, Math.max(0, (p - (ENTER + i * span)) / span));
var ease = Math.sin(t * Math.PI / 2);
var disc = $('.anat-disc', layer), label = $('.anat-label', layer);
/* stacked just inside the bowl mouth, deepest layer lowest */
/* Land INSIDE the mouth, not above the rim: the old target sat 26px above the
   bowl's top edge, so the stack hovered and read as sitting below it. */
var inBowl = natBowl + bowlH * 0.20 - (n - 1 - i) * STEP;
var out = (1 - ease) * (inBowl - nat[i]);
var offset = out + back * ((inBowl - nat[i]) - out);
if (disc) {
  /* Depth on the way out and on the way back in. Pieces start small,
     soft and slightly turned, as if sitting down in the bowl, then rise
     to full size and sharpen as they clear the rim. On the return they
     shrink and soften again rather than just sliding down, so the stack
     reads as going INTO the bowl rather than behind it. z-index is
     depth-ordered so the nearer discs overlap the further ones. */
  var rise = ease;
  var sink = back;
  var deep = (1 - rise) + sink * 0.9;
  var sc   = (0.62 + 0.38 * rise) * (1 - 0.34 * sink);
  var rot  = (i % 2 ? 1 : -1) * deep * 6;
  var bl   = deep * 3.2;
  disc.style.transform = 'translateY(' + offset + 'px) scale(' + sc.toFixed(3) + ') rotate(' + rot.toFixed(2) + 'deg)';
  disc.style.filter = bl > 0.06 ? 'blur(' + bl.toFixed(2) + 'px)' : 'none';
  disc.style.zIndex = String(10 + i);
  disc.style.opacity = String(Math.min(1, t / 0.18) * (1 - back));
}
if (label) {
  var appear = Math.min(1, t / 0.4) * (1 - back);
  label.style.opacity = String(appear);
  var dx = narrow ? -14 : (layer.classList.contains('side-l') ? -18 : 18);
  label.style.transform = 'translateX(' + ((1 - appear) * dx) + 'px)';
}
  });
};
var anatTick = false;
var onScroll = function () {
if (anatTick) return;
anatTick = true;
window.requestAnimationFrame(function () {
anatTick = false;
var total = anatomy.offsetHeight - window.innerHeight;
var p = total > 0 ? Math.min(1, Math.max(0, -anatomy.getBoundingClientRect().top / total)) : 1;
apply(p);
});
};
var onResize = function () { clearAnat(); startAnat(); };
var startAnat = function () {
if (reduced) { clearAnat(); return; }
document.documentElement.classList.add('anat-live');
measure();
window.addEventListener('scroll', onScroll, { passive: true });
window.addEventListener('resize', onResize);
var anatReflow = function () { measure(); onScroll(); };
window.addEventListener('load', anatReflow);
if (bowl) { var bimg = $('img', bowl); if (bimg && !bimg.complete) bimg.addEventListener('load', anatReflow); }
onScroll();
};
startAnat();
mobileMq.addEventListener('change', function () { clearAnat(); startAnat(); });
}
var mbar = $('.mbar');
var hero = $('.hero');
var signup = $('.signup');
if (mbar && hero) {
var syncBar = function () {
var pastHero = window.scrollY > hero.offsetHeight * 0.6;
var atForm = false;
if (signup) {
var r = signup.getBoundingClientRect();
atForm = r.top < window.innerHeight * 0.9 && r.bottom > 0;
}
mbar.classList.toggle('show', pastHero && !atForm);
};
window.addEventListener('scroll', syncBar, { passive: true });
window.addEventListener('resize', syncBar);
syncBar();
}
var cd = $('#cd'), cdVeil = $('#cd-veil'), cdLines = $('#cd-lines');
var cartBtn = $('.cart-btn'), cartN = $('.cart-n');
var FREE_AT = (window.TWB && window.TWB.freeShipAt) || 599;
var SHIP_FEE = (window.TWB && window.TWB.shipFee) || 49;
var rup = function (paise) { return '\u20B9' + Math.round(paise / 100); };
var money = function (paise) {
return '<span class="rs">\u20B9' + Math.round(paise / 100) + '</span>';
};
var paintCart = function (c) {
if (!c || typeof c.item_count !== 'number') return;
window.__twbCart = c;
if (cd) { cd.classList.remove('is-loading'); cd.classList.remove('is-err'); }
if (cartN) cartN.textContent = String(c.item_count);
if (cartBtn) cartBtn.setAttribute('aria-label', 'Cart, ' + c.item_count + ' items');
if (!cd) return;
cd.classList.toggle('is-empty', !c.item_count);
if (cdLines) cdLines.innerHTML = c.items.map(function (l, i) {
var img = l.image ? '<img src="' + l.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" width="80" height="80" loading="lazy">' : '';
return '<li class="cd-line">' +
'<a class="cd-thumb" href="' + l.url + '">' + img + '</a>' +
'<span><span class="cd-line-n">' + l.product_title + '</span>' +
(l.variant_title && l.variant_title.indexOf('Default') === -1 ? '<span class="cd-lasts">' + l.variant_title + '</span>' : '') +
'<span class="cd-line-ctl"><span class="cd-step">' +
'<button type="button" data-cdq="' + (l.quantity - 1) + '" data-line="' + (i + 1) + '" aria-label="Reduce">\u2212</button>' +
'<span>' + l.quantity + '</span>' +
'<button type="button" data-cdq="' + (l.quantity + 1) + '" data-line="' + (i + 1) + '" aria-label="Increase">+</button></span>' +
'<button class="cd-rm" type="button" data-cdq="0" data-line="' + (i + 1) + '">Remove</button></span></span>' +
'<span class="cd-line-end">' + money(l.final_line_price) + '</span></li>';
}).join('');
var subEl = $('#cd-sub'); if (subEl) subEl.innerHTML = money(c.total_price);
/* Suggestions: what to add to reach free delivery, chosen by relevance.
   Data is server-rendered by the twb-pairs snippet, so there is no fetch and
   no hardcoded product. Rules:
     - anchor on the most recently added cart item that has pairings
     - never suggest something already in the cart
     - when there is a gap, prefer partners that actually CLEAR the threshold,
       because a suggestion that leaves you short is not a suggestion
     - the footnote is selected from the computed state, so it can never claim
       something the arithmetic does not support
     - closing the gap always costs more than the delivery charge it removes,
       and the copy says so rather than implying a saving */
var readJSON = function (id) {
  var el = document.getElementById(id);
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch (e) { return null; }
};
var CATALOG = window.__twbCatalog || (window.__twbCatalog = readJSON('twb-catalog'));
var PAIRS = window.__twbPairs || (window.__twbPairs = readJSON('twb-pairs'));
var sugg = $('#cd-sugg'), suggList = $('#cd-sugg-list'), suggNote = $('#cd-sugg-note');
if (sugg && suggList && CATALOG && PAIRS) {
  var gap = Math.max(0, FREE_AT * 100 - c.total_price);
  var inCart = {};
  c.items.forEach(function (l) { if (l.handle) inCart[l.handle] = true; });
  var anchors = [];
  for (var i = c.items.length - 1; i >= 0; i--) {
    var h = c.items[i].handle;
    if (h && PAIRS[h] && anchors.indexOf(h) === -1) anchors.push(h);
  }
  var cand = [];
  anchors.forEach(function (a) {
    PAIRS[a].forEach(function (pair) {
      var hh = pair[0];
      if (inCart[hh]) return;
      if (!CATALOG[hh]) return;
      for (var k = 0; k < cand.length; k++) { if (cand[k].h === hh) return; }
      cand.push({ h: hh, why: pair[1] });
    });
  });
  if (!c.item_count || !cand.length) {
    sugg.hidden = true;
  } else {
    var show, note;
    if (gap > 0) {
      var closers = cand.filter(function (x) { return CATALOG[x.h].p >= gap; });
      if (closers.length >= 2) {
        show = closers.slice(0, 4);
        note = 'Any of these clears the ' + rup(FREE_AT * 100) + ' mark and delivery drops to zero. Both cost more than the ' + rup(SHIP_FEE * 100) + ', so add it for the food, not the maths.';
      } else if (closers.length === 1) {
        show = closers;
        var extra = CATALOG[closers[0].h].p - gap;
        note = 'This clears the ' + rup(FREE_AT * 100) + ' mark and delivery drops to zero. It costs more than the ' + rup(SHIP_FEE * 100) + ', so add it for the food, not the maths.';
      } else {
        show = cand.slice(0, 4);
        note = 'Neither of these reaches ' + rup(FREE_AT * 100) + ' on its own, so delivery stays ' + rup(SHIP_FEE * 100) + ' on this order.';
      }
    } else {
      show = cand.slice(0, 4);
      note = '';   /* delivery already free: the rail speaks for itself */
    }
    var keepX = suggList.scrollLeft;   /* a quantity tap repaints the rail; don't fling it back to card one */
    suggList.innerHTML = show.map(function (x) {
      var pr = CATALOG[x.h];
      return '<li class="cd-sugg-card">'
        + '<a class="cd-sugg-media" href="/products/' + x.h + '" tabindex="-1" aria-hidden="true">'
        + (pr.i ? '<img src="' + pr.i + '" alt="" width="88" height="88" loading="lazy" decoding="async">' : '')
        + '</a>'
        + '<span class="cd-sugg-body">'
        + '<span class="cd-sugg-top">'
        + '<a class="cd-sugg-name" href="/products/' + x.h + '">' + pr.t + '</a>'
        + '<span class="cd-sugg-price">' + money(pr.p) + '</span>'
        + '</span>'
        + '<span class="cd-sugg-why">' + x.why + '</span>'
        + '</span>'
        + '<button class="btn-add" type="button" data-label="Add" data-add="' + pr.v + '">Add</button>'
        + '</li>';
    }).join('');
    suggList.scrollLeft = keepX;
    if (suggNote) { suggNote.textContent = note; suggNote.hidden = !note; }
    sugg.hidden = false;
    /* bind the freshly rendered Add buttons */
    $$('[data-add]', suggList).forEach(function (b) {
      b.addEventListener('click', function () { addToCart(+b.getAttribute('data-add'), 1, b); });
    });
  }
}
var line = $('#cd-ship-line'), fill = $('#cd-bar-fill');
if (line && fill) {
var target = FREE_AT * 100;
if (c.total_price >= target) {
line.innerHTML = '<b>Delivery is free on this order.</b>';
fill.style.width = '100%'; fill.classList.add('full');
} else {
line.innerHTML = money(target - c.total_price) + ' away from free delivery. '+ '<span class="cd-ship-alt">Or check out now and pay ' + money(SHIP_FEE * 100) + ' delivery.</span>';
fill.style.width = Math.round(c.total_price / target * 100) + '%'; fill.classList.remove('full');
}
}
};
var getCart = function () {
return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
.then(function (r) { return r.json(); });
};
var openCart = function () {
if (!cd) return;
var wasClosed = cd.hidden;
cd.hidden = false; cdVeil.hidden = false;
window.requestAnimationFrame(function () { cd.classList.add('on'); cdVeil.classList.add('on'); });
document.body.style.overflow = 'hidden';
/* Only steal focus when the drawer actually opens. addToCart calls openCart on
   every add, including the rail's own Add buttons, so focusing unconditionally
   threw a keyboard user back to the close X after every single add. */
if (wasClosed) { var x = $('#cd-x'); if (x) x.focus(); }
};
var closeCart = function () {
if (!cd) return;
cd.classList.remove('on'); cdVeil.classList.remove('on');
document.body.style.overflow = '';
window.setTimeout(function () { cd.hidden = true; cdVeil.hidden = true; }, 280);
};
var changeLine = function (line, qty) {
return fetch(window.Shopify.routes.root + 'cart/change.js', {
method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ line: line, quantity: qty })
}).then(function (r) { return r.json(); }).then(paintCart);
};
var setBtn = function (b, word) {
/* swap the WORD only. The Add button carries a running total in #atc-tot and
   textContent used to wipe it, so after one add the button stopped quoting a
   price. The resting word comes from data-label, so a second in-flight call
   can never capture "Adding" and restore it as the label. */
if (!b) return;
var slot = b.querySelector('#atc-label') || b.querySelector('.pbar-label');
if (slot) { slot.textContent = word; } else { b.textContent = word; }
};
var restBtn = function (b) { return (b && b.getAttribute('data-label')) || 'Add to cart'; };
var atcErr = function (msg) {
var e = document.getElementById('atc-err');
if (!e) return;
if (msg) { e.textContent = msg; e.hidden = false; } else { e.hidden = true; }
};
var addToCart = function (id, qty, btn) {
var label = restBtn(btn);
var pbar = document.getElementById('pbar-atc');
atcErr('');
if (btn) { setBtn(btn, 'Adding'); btn.setAttribute('disabled', ''); }
if (pbar && pbar !== btn) { setBtn(pbar, 'Adding'); pbar.setAttribute('disabled', ''); }
/* The drawer used to wait for cart/add.js AND cart.js before it opened: two
   sequential round trips with nothing on screen. It opens on the click now
   and fills in when the data lands. */
if (cd) { if (window.__twbCart) { paintCart(window.__twbCart); } cd.classList.add('is-loading'); }
openCart();
return fetch(window.Shopify.routes.root + 'cart/add.js', {
method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
}).then(function (r) {
if (!r.ok) { return r.json().then(function (d) { throw new Error((d && d.description) || 'add failed'); }); }
return r.json();
}).then(function () {
return getCart();
}).then(function (c) {
paintCart(c);
if (btn) {
setBtn(btn, 'Added'); btn.classList.add('ok');
if (cartBtn) { cartBtn.classList.remove('bump'); void cartBtn.offsetWidth; cartBtn.classList.add('bump'); }
window.setTimeout(function () { setBtn(btn, label); btn.classList.remove('ok'); btn.removeAttribute('disabled'); if (pbar && pbar !== btn) { setBtn(pbar, restBtn(pbar)); pbar.removeAttribute('disabled'); } }, 900);
}
}).catch(function () {
if (cd) { cd.classList.remove('is-loading'); cd.classList.add('is-err'); }
atcErr('Could not add that just now. Check your connection and try again.'); if (btn) { setBtn(btn, label); btn.classList.remove('ok'); btn.removeAttribute('disabled'); } if (pbar && pbar !== btn) { setBtn(pbar, restBtn(pbar)); pbar.removeAttribute('disabled'); }
});
};
if (cd) {
var cdX = $('#cd-x'); if (cdX) cdX.addEventListener('click', closeCart);
cdVeil.addEventListener('click', closeCart);
document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !cd.hidden) closeCart(); });
var shopLink = $('#cd-shop'); if (shopLink) shopLink.addEventListener('click', closeCart);
if (cdLines) cdLines.addEventListener('click', function (e) {
var q = e.target.closest('[data-cdq]');
if (!q) return;
changeLine(+q.getAttribute('data-line'), +q.getAttribute('data-cdq'));
});
}
if (cartBtn) {
cartBtn.addEventListener('click', function (e) {
if (!cd) return;
e.preventDefault();
/* open on the click, never after a round trip; paint from the cached cart
   instantly so the drawer is never blank, and refresh behind it */
if (window.__twbCart) { paintCart(window.__twbCart); } else if (cd) { cd.classList.add('is-loading'); }
openCart();
getCart().then(function (c) { paintCart(c); }).catch(function () { if (cd) { cd.classList.remove('is-loading'); cd.classList.add('is-err'); } });
});
}
$$('[data-add]').forEach(function (btn) {
btn.addEventListener('click', function () { addToCart(+btn.getAttribute('data-add'), 1, btn); });
});
/* pack option cards. Each card carries the REAL cart total for its quantity,
   server-rendered from the live price, so this only syncs form state and the
   button label. Nothing here computes a discount. */
var packBtns = document.querySelectorAll('.pack');
var qtyInput = document.getElementById('qty');
var atcTot = document.getElementById('atc-tot');
var money0 = function (p) { return '<span class="rs">\u20B9' + Math.round(p / 100) + '</span>'; };
if (packBtns.length && qtyInput) {
  /* the headline price follows the selected pack. All of it is arithmetic on
     the variant's own unit price, held as data attributes on .price-big, so no
     figure is ever typed and no variant is swapped: packs are quantity. */
  var priceEl = document.querySelector('.price-big[data-price]');
  var pNow = document.getElementById('p-now');
  var pCmp = document.getElementById('p-compare');
  var pLine = document.getElementById('p-unitline');
  var rupee = function (paise) { return String(Math.round(paise / 100)); };
  var syncPrice = function (n) {
    if (!priceEl) return;
    var unit = +priceEl.getAttribute('data-unit') || 0;
    var unitCmp = +priceEl.getAttribute('data-unit-compare') || 0;
    if (pNow) pNow.textContent = rupee(unit * n);
    if (pCmp && unitCmp > unit) pCmp.textContent = rupee(unitCmp * n);
    /* the sticky bar must never quote a different number than the buy box */
    var bNow = document.getElementById('pb-now');
    var bCmp = document.getElementById('pb-compare');
    if (bNow) bNow.textContent = rupee(unit * n);
    if (bCmp && unitCmp > unit) bCmp.textContent = rupee(unitCmp * n);
    if (pLine) {
      pLine.innerHTML = (n > 1 ? n + ' packs &middot; ' : '1 pack &middot; ')
        + '<span class="rs">\u20B9' + rupee(unit) + '</span> each';
    }
  };
  var selectPack = function (b) {
    var n = parseInt(b.getAttribute('data-pack'), 10) || 1;
    qtyInput.value = n;
    syncPrice(n);
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    packBtns.forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
    var down = document.getElementById('q-down');
    if (down) down.disabled = n <= 1;
    if (atcTot) atcTot.innerHTML = ' \u00B7 ' + money0(+b.getAttribute('data-total'));
    var pb = document.querySelector('.pbar-tot');
    if (pb) pb.innerHTML = ' \u00B7 ' + money0(+b.getAttribute('data-total'));
  };
  packBtns.forEach(function (b) {
    b.addEventListener('click', function () { selectPack(b); });
  });
  /* manual qty edits: match a card if one fits, else clear the selection and
     price the button from the live unit price so it never lies */
  qtyInput.addEventListener('input', function () {
    var q = +qtyInput.value || 1, matched = null;
    syncPrice(q);
    packBtns.forEach(function (x) {
      var hit = +x.getAttribute('data-pack') === q;
      x.setAttribute('aria-checked', hit ? 'true' : 'false');
      if (hit) matched = x;
    });
    /* one computed string, written to BOTH the button and the sticky bar, so
       they can never quote different numbers */
    var one = packBtns[0] ? +packBtns[0].getAttribute('data-total') : 0;
    var totp = matched ? +matched.getAttribute('data-total') : one * q;
    var txt = totp ? ' \u00B7 ' + money0(totp) : '';
    if (atcTot) atcTot.innerHTML = txt;
    var pbTot = document.querySelector('.pbar-tot');
    if (pbTot) pbTot.innerHTML = txt;
  });
}
var pform = $('#pform');
if (pform) {
pform.addEventListener('submit', function (e) {
e.preventDefault();
var id = pform.querySelector('[name="id"]').value;
var q = pform.querySelector('[name="quantity"]');
addToCart(+id, q ? +q.value : 1, $('#atc'));
});
$$('[data-variant]').forEach(function (b) {
b.addEventListener('click', function () {
$$('[data-variant]').forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
b.setAttribute('aria-selected', 'true');
pform.querySelector('[name="id"]').value = b.getAttribute('data-variant');
});
});
}
var pbarAtc = $('#pbar-atc');
if (pbarAtc && pform) pbarAtc.addEventListener('click', function () { pform.requestSubmit ? pform.requestSubmit() : pform.dispatchEvent(new Event('submit', { cancelable: true })); });
$$('[data-cat-go]').forEach(function (t) {
t.addEventListener('click', function () {
var f = $$('.filter').filter(function (x) { return x.getAttribute('data-filter') === t.getAttribute('data-cat-go'); })[0];
if (f) f.click();
var g = $('#grid'); if (g) g.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
});
});
var form = $('.signup-form');
var err = $('#email-err');
if (form) {
var input = $('input[type="email"]', form);
var sbtn = $('button', form);
input.addEventListener('input', function () {
input.removeAttribute('aria-invalid');
if (err) err.classList.remove('show');
});
/* This is a real Shopify form. preventDefault used to run unconditionally and
   then fake a success message, so every address typed into it was silently
   discarded. Only invalid input is blocked now; a valid address submits
   natively to Shopify. It is form_type contact since the bulk enquiry change,
   so the textarea body travels with the email. Only the email is validated
   here; a blank query still sends. */
form.addEventListener('submit', function (e) {
if (!input.value || !input.checkValidity()) {
e.preventDefault();
input.setAttribute('aria-invalid', 'true');
if (err) err.classList.add('show');
input.focus();
return;
}
input.removeAttribute('aria-invalid');
if (err) err.classList.remove('show');
sbtn.textContent = 'Sending';
sbtn.setAttribute('disabled', '');
});
/* The block is a bulk enquiry form now, form_type contact, and a contact post
   returns contact_posted=true. It never sets customer_posted, so the old check
   would have confirmed nothing. */
if (/[?&]contact_posted=true/.test(window.location.search)) {
sbtn.textContent = 'Enquiry sent';
sbtn.setAttribute('disabled', '');
input.setAttribute('disabled', '');
var q = form.querySelector('textarea');
if (q) q.setAttribute('disabled', '');
}
}
var gal = $('#gal');
if (gal) {
var frames = $$('.gal-frame', gal);
var thumbs = $$('.thumb-btn');
var current = 0;
var galCap = document.getElementById('gal-cap');
var show = function (i) {
current = i;
frames.forEach(function (f, n) { f.classList.toggle('on', n === i); });
thumbs.forEach(function (t, n) { t.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
/* say what the frame shows; the alt text is already authored per image */
if (galCap) {
var im = frames[i] && frames[i].querySelector('img');
if (im && im.alt) { galCap.textContent = im.alt; galCap.hidden = false; } else { galCap.hidden = true; }
}
};
thumbs.forEach(function (t, i) {
t.addEventListener('click', function () { show(i); });
t.addEventListener('keydown', function (e) {
var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
if (!dir) return;
e.preventDefault();
var n = (i + dir + thumbs.length) % thumbs.length;
thumbs[n].focus(); show(n);
});
});
var lens = $('#lens'), lensIn = $('#lens-in'), lensClose = $('#lens-close');
var openLens = function () {
if (!lens) return;
lensIn.innerHTML = frames[current].innerHTML;
lens.classList.add('on');
document.body.style.overflow = 'hidden';
lensClose.focus();
};
var closeLens = function () {
lens.classList.remove('on');
document.body.style.overflow = '';
lensIn.innerHTML = '';
};
gal.addEventListener('click', function (e) { if (!e.target.closest('.gal-zoom')) openLens(); });
var zoomBtn = $('#zoom');
if (zoomBtn) zoomBtn.addEventListener('click', function (e) { e.stopPropagation(); openLens(); });
if (lens) {
lensClose.addEventListener('click', closeLens);
lens.addEventListener('click', function (e) { if (e.target === lens) closeLens(); });
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape' && lens.classList.contains('on')) closeLens();
});
}
}
var qty = $('#qty'), qUp = $('#q-up'), qDown = $('#q-down');
if (qty && qUp && qDown) {
var syncQty = function () {
var v = Math.min(9, Math.max(1, parseInt(qty.value, 10) || 1));
qty.value = v;
qDown.disabled = v <= 1;
qUp.disabled = v >= 9;
};
qUp.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; syncQty(); qty.dispatchEvent(new Event('input', { bubbles: true })); });
qDown.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) - 1; syncQty();  qty.dispatchEvent(new Event('input', { bubbles: true }));});
qty.addEventListener('change', syncQty);
syncQty();
}
var pinForm = $('#pin-form');
if (pinForm) {
var DISPATCH = new Date();
DISPATCH.setDate(DISPATCH.getDate() + 1);
var METROS = {
'400': ['Mumbai', 2], '401': ['Mumbai', 2], '410': ['Navi Mumbai', 2],
'411': ['Pune', 3], '412': ['Pune', 3],
'110': ['Delhi', 4], '201': ['Noida', 4], '122': ['Gurugram', 4],
'560': ['Bengaluru', 4], '562': ['Bengaluru', 4],
'600': ['Chennai', 5], '500': ['Hyderabad', 5], '700': ['Kolkata', 5],
'380': ['Ahmedabad', 4]
};
var DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
pinForm.addEventListener('submit', function (e) {
e.preventDefault();
var input = $('#pin'), out = $('#pin-out');
var v = (input.value || '').trim();
out.classList.add('on');
if (!/^[1-9][0-9]{5}$/.test(v)) {
input.setAttribute('aria-invalid', 'true');
out.className = 'pin-out on no';
out.textContent = 'Enter a valid 6 digit pincode.';
return;
}
input.removeAttribute('aria-invalid');
var hit = METROS[v.slice(0, 3)];
if (!hit) {
out.className = 'pin-out on no';
out.innerHTML = 'Not serviceable at launch. We start with metro cities and widen from there. ' +
'<a href="' + (window.TWB && window.TWB.rootUrl || '/') + '#signup" style="color:var(--ink);font-weight:700">Join the list</a> and we will tell you when your pincode opens.';
return;
}
var d = new Date(DISPATCH.getTime());
d.setDate(d.getDate() + hit[1]);
out.className = 'pin-out on';
out.innerHTML = 'Delivers to <b>' + hit[0] + '</b>. Order today and it arrives by <b>' +
DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()] + '</b>.';
});
}
var qaForm = $('#qa-form');
if (qaForm) {
qaForm.addEventListener('submit', function (e) {
e.preventDefault();
var box = $('#qa-q'), ok = $('#qa-ok');
if (!box.value.trim()) { box.focus(); return; }
box.value = '';
box.setAttribute('disabled', '');
qaForm.querySelector('button').setAttribute('disabled', '');
if (ok) ok.classList.add('on');
});
}
var pbar = $('#pbar'), atc = $('#atc');
if (pbar && atc) {
var syncPbar = function () {
var r = atc.getBoundingClientRect();
pbar.classList.toggle('show', r.bottom < 0);
};
window.addEventListener('scroll', syncPbar, { passive: true });
window.addEventListener('resize', syncPbar);
syncPbar();
}
var pbarAtc = $('#pbar-atc');
if (pbarAtc && atc) pbarAtc.addEventListener('click', function () { atc.click(); });
/* The PDP used to pin whichever column was shorter. Once the buy column grew
   with pack cards, trust grid and accordions, "shorter" became the gallery, so
   the product images pinned themselves and followed the scroll. Omkar asked for
   that off, so neither column sticks now. The mobile buy bar already covers the
   job this was doing, keeping a price and an Add button in reach. */
$$('.foot-col').forEach(function (col) {
var h = $('.foot-h', col);
if (!h) return;
h.setAttribute('role', 'button');
h.setAttribute('tabindex', '0');
var toggle = function () {
if (!mobileMq.matches) return;
col.classList.toggle('open');
};
h.addEventListener('click', toggle);
h.addEventListener('keydown', function (e) {
if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
});
});

  /* ================= welcome popup: once per browser ================= */
  var wpop = document.getElementById('wpop');
  if (wpop && !localStorage.getItem('twb-welcome-seen')) {
    /* The popup used to fire 5s after load, landing on top of the hero before
       anyone had read the headline. The client screenshotted exactly that on
       18 Aug. It now waits until the hero has been scrolled past, with a long
       timed fallback, so it never covers the first screen. */
    var popShown = false;
    var showPop = function () {
      if (popShown) return;
      popShown = true;
      wpop.hidden = false;
      window.removeEventListener('scroll', onPopScroll);
    };
    var onPopScroll = function () {
      var hero = $('.hero');
      var past = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
      if (past) showPop();
    };
    window.addEventListener('scroll', onPopScroll, { passive: true });
    window.setTimeout(showPop, 30000);
    var closePop = function () { wpop.hidden = true; localStorage.setItem('twb-welcome-seen', '1'); };
    document.getElementById('wpop-x').addEventListener('click', closePop);
    wpop.addEventListener('click', function (e) { if (e.target === wpop) closePop(); });
    var wForm = document.getElementById('wpop-form');
    if (wForm) {
      wForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var em = document.getElementById('wpop-email').value;
        if (!em) return;
        /* best-effort capture into Shopify customers; the code shows either way */
        try {
          var fd = new FormData();
          fd.append('form_type', 'customer'); fd.append('utf8', '\u2713');
          fd.append('contact[email]', em); fd.append('contact[tags]', 'newsletter,welcome-pop');
          fetch('/contact', { method: 'POST', body: fd }).catch(function () {});
        } catch (err) {}
        wForm.hidden = true;
        document.getElementById('wpop-copy').hidden = false;
      });
    }
    document.getElementById('wpop-copy').addEventListener('click', function () {
      var b = this;
      try { navigator.clipboard.writeText('WELCOME5'); } catch (e) {}
      b.firstChild.textContent = 'COPIED ';
      window.setTimeout(closePop, 900);
    });
  }


  /* Mobile rails open flush at the first card. A stale scroll position
     restored by the browser leaves a sliver of the previous card cut off at
     the left edge, which the client flagged on the bundle rail (18 Aug). */
  ['.bund-grid', '.cat-tiles', '.jrnl'].forEach(function (sel) {
    var rail = $(sel);
    if (rail && rail.scrollLeft !== 0) rail.scrollLeft = 0;
  });
})();

/* Cart drawer copy-code widget. Clipboard API where available, with a select
   and execCommand fallback for older mobile browsers, so the code is always
   obtainable rather than silently failing. */
(function () {
  var btn = document.getElementById('cd-code-copy');
  if (!btn) return;
  var act = document.getElementById('cd-code-act');
  var revert = null;
  btn.addEventListener('click', function () {
    var code = btn.getAttribute('data-code') || '';
    var done = function (okState) {
      if (!act) return;
      act.textContent = okState ? 'Copied' : 'Select';
      btn.classList.toggle('is-copied', !!okState);
      if (revert) window.clearTimeout(revert);
      revert = window.setTimeout(function () {
        act.textContent = 'Copy';
        btn.classList.remove('is-copied');
      }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () { done(true); }).catch(function () { fallback(); });
    } else { fallback(); }
    function fallback() {
      try {
        var t = document.createElement('textarea');
        t.value = code; t.setAttribute('readonly', '');
        t.style.position = 'absolute'; t.style.left = '-9999px';
        document.body.appendChild(t); t.select();
        var okState = document.execCommand('copy');
        document.body.removeChild(t);
        done(okState);
      } catch (e) { done(false); }
    }
  });
})();
